

/* BEGIN utility-leg-bag-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester, a military-standard SBS zipper, and secure KAM buckles provide durable construction for hiking, airsoft, and outdoor use.","An adjustable waist belt fits 76–117 cm (30–46 in), while the adjustable leg strap fits 28–79 cm (11–31 in); a D-ring supports convenient webbing adjustment.","A dedicated compartment holds a flashlight or knife, and a smaller compartment organizes compact essentials."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-waterproof-tactical-outdoor-hiking-airsoft-utility-leg-bag') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END utility-leg-bag-buyer-highlights-20260731 */
